import * as React from 'react';
import { OptionList } from './SelectableOption.styles';

export function FormInputCheckbox({
  label, registration, checked, onChange,
}) {
  return (
    <OptionList className="row-layout">
      <label className="option-card shape-square">
        {registration === undefined ? (
          <input type="checkbox" checked={checked} onChange={onChange} />
        ) : (
          <input type="checkbox" {...registration} />
        )}
        <span className="option-indicator">
          <svg viewBox="0 0 16 12" fill="none">
            <path d="M1 6l4 4 9-9" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
        <span className="option-label">{label}</span>
      </label>
    </OptionList>
  );
}
